
































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import {
  RoEmailViewModel,
  RepairOrderViewModel,
  AttachmentInfoViewModel,
} from '@/models/fixedops/repairorder';
import { VHeaders, PaginationModel } from '@/models/pagedlistmodel';
import { NotificationHelper as _notification } from '@/helper/notifications.helper';
import { Base } from '../common/base';
import { repairOrderService, attachmentService } from '@/shared';

@Component({
  components: {
    Grid: () => import('../common/app.grid.vue'),
  },
  props: ['roDetails', 'attachments', 'signature'],
})
export default class RepairOrderSendEmailComponent extends Base {
  public constants: any = {
    roNumber: '',
    froms: [],
    loading: false,
    checked: false,
  };
  public roDetails: RepairOrderViewModel;
  public attachments: AttachmentInfoViewModel[];
  public emailAttachments: AttachmentInfoViewModel[];
  public pagedAttachments: AttachmentInfoViewModel[] = [];
  public emailModel: RoEmailViewModel = {
    isEmail1: true,
    isEmail2: false,
  };
  public paginations = new PaginationModel('name');
  public signature: any;
  public isEmailSendLoading: boolean = false;

  public headers: VHeaders[] = [
    {
      align: 'left',
      sortable: false,
      text: '',
      value: 'selected',
      fieldType: 'checkbox',
      onChange: (item) => {
        this.addAttachment(item);
      },
    },
    {
      align: 'left',
      sortable: false,
      text: this.$parent.$t(
        'repairOrderDetailSendEmail.sendMailGrid.attachmentType'
      ) as string,
      value: 'attachmentTypeName',
    },
    {
      align: 'left',
      sortable: false,
      text: this.$parent.$t(
        'repairOrderDetailSendEmail.sendMailGrid.user'
      ) as string,
      value: 'userName',
    },
    {
      align: 'left',
      sortable: false,
      text: this.$parent.$t(
        'repairOrderDetailSendEmail.sendMailGrid.comment'
      ) as string,
      value: 'comment',
    },
    {
      align: 'left',
      sortable: false,
      text: this.$parent.$t(
        'repairOrderDetailSendEmail.sendMailGrid.uploadedAt'
      ) as string,
      value: 'createdDateTime',
      fieldType: 'date',
      format: 'MMMM Do YYYY h:mm A',
    },

    {
      align: 'center',
      text: this.$parent.$t(
        'repairOrderDetailSendEmail.sendMailGrid.actions'
      ) as string,
      isNotDataProp: true,
      sortable: false,
    },
  ];
  public actions: any[] = [
    {
      type: 'button',
      icon: 'fas fa-eye',
      title: this.$parent.$t(
        'repairOrderDetailSendEmail.sendMailGrid.gridActions.viewAttachment'
      ) as string,
      loading: false,
      action: (model, action: any) => {
        this.viewAttachment(model.id, action);
      },
    },
  ];

  public mounted(): void {
    this.constants.froms = [
      {
        id: this.roDetails.loggedInUserId,
        email: this.roDetails.loggedInUserEmail,
      },
    ];
    if (this.roDetails.advisorEmail) {
      this.constants.froms.push({
        id: this.roDetails.advisorUserId,
        email: this.roDetails.advisorEmail,
      });
    }
    this.emailModel.fromEmailUserId = this.constants.froms[0].id;
    this.emailModel.storeId = this.roDetails.storeId;
    this.emailModel.customerEmail1 = this.roDetails.customerEmail1;
    this.emailModel.customerEmail2 = this.roDetails.customerEmail2;
    this.emailModel.roNumber = this.roDetails.roNumber;
    this.emailModel.customerName = this.roDetails.customerName;
    this.emailModel.status = this.roDetails.status;
    this.emailModel.serviceAdvisor = this.roDetails.serviceAdvisor;
    if (this.roDetails.buttonType) {
      this.emailModel.buttonType = this.roDetails.buttonType;
    } else {
      this.emailModel.buttonType = 'email';
    }

    this.emailModel.view = 'detail';
    this.emailModel.subject = `${this.roDetails.storeName} - ${this.$t(
      'repairOrderDetailSendEmail.repairOrder'
    )} ${this.roDetails.roNumber}`;
    this.emailModel.vinNumber = this.roDetails.vin;
    this.emailAttachments = this.attachments.filter((r) => {
      return (
        r.attachmentTypeName !== 'Text' &&
        r.attachmentTypeName !== 'Voice Recording' &&
        r.attachmentTypeName !== 'Voice Transcription'
      );
    });
    this.pagedAttachments = this.emailAttachments || [];
    this.paginations.totalItems = this.pagedAttachments.length;
  }

  public addAttachment(attachment: AttachmentInfoViewModel): boolean {
    if (!this.emailModel.attachmentIdArray) {
      this.emailModel.attachmentIdArray = [];
    }
    if (attachment.selected) {
      this.emailModel.attachmentIdArray.push(attachment.id);
    } else {
      const index = this.emailModel.attachmentIdArray.indexOf(attachment.id);
      if (index > -1) {
        this.emailModel.attachmentIdArray.splice(index, 1);
      }
    }
    return true;
  }

  public updatePaging(paging): void {
    this.paginations = paging;
  }

  public cancel(): void {
    this.$emit('updateflag', 'showSendEmailPopup', false);
    this.$destroy();
  }

  public async sendEmail(): Promise<void> {
    if(this.validateForm()){
      try {
        this.isEmailSendLoading = true;
        if (!this.emailModel.isEmail1 && !this.emailModel.isEmail2) {
          // this.showAlert(
          //   false,
          //   this.$t('repairOrderDetailSendEmail.alertSelectOneEmail')
          // );
          return;
        }
        if (this.emailModel.isEmail1 && !this.emailModel.customerEmail1) {
          // this.showAlert(
          //   false,
          //   this.$t('repairOrderDetailSendEmail.alertHomeEmailCannotEmpty')
          // );
          return;
        }
        if (this.emailModel.isEmail2 && !this.emailModel.customerEmail2) {
          // this.showAlert(
          //   false,
          //   this.$t('repairOrderDetailSendEmail.alertWorkEmailCannotEmpty')
          // );
          return;
        }

        if (this.emailModel.customerEmail1) {
          let signature = null;
          if (this.signature) {
            signature = this.signature.save('image/svg');
          }

          if (this.emailModel.attachmentIdArray) {
            this.emailModel.checkedArray = this.emailModel.attachmentIdArray.join(
              ','
            );
          }
          this.emailModel.sign = signature;
          await repairOrderService.sendROEmail(this.emailModel);
          this.showAlert(
            true,
            this.$t('repairOrderDetailSendEmail.alertEmailSentSuccessfully')
          );
          this.$emit('updateflag', 'showSendEmailPopup', false);
        } else {
          this.showAlert(
            false,
            this.$t('repairOrderDetailSendEmail.alertCustomerEmailCannotEmpty')
          );
        }
      } finally {
        this.isEmailSendLoading = false;
      }
    }
  }

  public async viewAttachment(
    attachmentId: string,
    action: any
  ): Promise<void> {
    try {
      action.loading = true;
      await attachmentService.viewAttachmentAsync(attachmentId);
    } finally {
      action.loading = false;
    }
  }
}
